import { useEffect } from "react";
import { ContainerV2, H1, P } from "../../Atoms";
import { CardStoreList } from "./Components/CardStoreList";
import { useStoreV2 } from "./useStoreV2";
import { Tracking } from "../../../services/Tracking";

export const StoreV2 = () => {
  const { stepIndicator, lojas, uuidLoja, setUuidLoja, submitAgendamento } =
    useStoreV2();

  useEffect(() => {
    Tracking.pageView("mapa:agendamento/loja:pageview");
  });

  return (
    <ContainerV2
      nextButton={{
        title: "Avançar",
        disabled: !uuidLoja,
        onClick: submitAgendamento,
      }}
    >
      {stepIndicator}
      <H1 className="mb-4 mt-8">Loja / Ciretran</H1>
      <P className="mb-6">
        Selecione a unidade mais próxima ou a que melhor se encaixa na sua
        rotina.
      </P>

      <CardStoreList stores={lojas} onValueChange={setUuidLoja} />
    </ContainerV2>
  );
};
